import { render, staticRenderFns } from "./TherapistsList.vue?vue&type=template&id=06ae0c28&"
import script from "./TherapistsList.vue?vue&type=script&lang=js&"
export * from "./TherapistsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports